export default function ConfirmDialog({
  message,
  onConfirm,
  onCancel,
  confirmLabel = "Delete",
  confirmClassName = "rounded-xl bg-red-600 px-4 py-2 text-white text-sm font-semibold hover:bg-red-700",
}) {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl border w-full max-w-[380px] max-h-[90vh] overflow-y-auto p-6">
        <p className="text-sm text-gray-700 mb-6">{message}</p>
        <div className="flex flex-col sm:flex-row justify-end gap-3">
          <button
            type="button"
            className="w-full sm:w-auto rounded-xl border px-4 py-2 text-sm font-semibold hover:bg-gray-50"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button type="button" className={`w-full sm:w-auto ${confirmClassName}`} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}